module.exports = __webpack_public_path__ + "img/dice-d10.e498c1b5.svg";